import { Injectable } from '@angular/core';

import { PartnerIdentificationType } from '../models/partner-identification-type';
import { IdentificationType, IdentificationTypeQualifier } from '../models/identification-type';

import { JsonHttpService } from '../../shared/http/json-http.service';
import { HttpParams } from '@angular/common/http';

@Injectable({
    providedIn: 'root'
})
export class PartnerIdentificationTypeService {

    constructor(private httpService: JsonHttpService) { }


    // Identification Types

    getIdentificationTypes(includeQualifiers: boolean): Promise<IdentificationType[]> {
        const options = { params: new HttpParams().set('includeQualifiers', `${includeQualifiers}`) };
        return this.httpService.get('/api/partners/identification/get-identification-types', options).toPromise();
    }

    saveIdentificationType(identificationType: IdentificationType): Promise<IdentificationType> {
        // Don't send qualifiers; they are not saved by this method
        const newIdentificationType = { ...identificationType, Qualifiers: [] };
        return this.httpService.post('/api/partners/identification/save-identification-type', newIdentificationType, null, false).toPromise();
    }

    deleteIdentificationType(id: number): Promise<void> {
        const options = { params: new HttpParams().set('id', `${id}`) };
        return this.httpService.post('/api/partners/identification/delete-identification-type', null, options, false).toPromise();
    }


    // Identification Type Qualifiers

    getIdentificationTypeQualifiers(): Promise<IdentificationTypeQualifier[]> {
        return this.httpService.get('/api/partners/identification/get-identification-type-qualifiers').toPromise();
    }

    saveIdentificationTypeQualifier(identificationTypeQualifier: IdentificationTypeQualifier): Promise<IdentificationTypeQualifier> {
        return this.httpService.post('/api/partners/identification/save-identification-type-qualifier', identificationTypeQualifier).toPromise();
    }

    deleteIdentificationTypeQualifier(id: number): Promise<void> {
        const options = { params: new HttpParams().set('id', `${id}`) };
        return this.httpService.post('/api/partners/identification/delete-identification-type-qualifier', null, options).toPromise();
    }


    // Partner Identification Types

    getPartnerIdentificationTypes(partnerId: number): Promise<PartnerIdentificationType[]> {
        const options = { params: new HttpParams().set('partnerId', `${partnerId}`) };
        return this.httpService.get('/api/partners/identification/get-partner-identification-types', options).toPromise();
    }

    savePartnerIdentificationType(partnerIdentification: PartnerIdentificationType): Promise<PartnerIdentificationType> {
        return this.httpService.post('/api/partners/identification/save-partner-identification-type', partnerIdentification).toPromise();
    }

    deletePartnerIdentificationType(partnerIdentificationTypeId: number): Promise<void> {
        const options = { params: new HttpParams().set('partnerIdentificationId', `${partnerIdentificationTypeId}`) };
        return this.httpService.post('/api/partners/identification/delete-partner-identification-type', null, options).toPromise();
    }
}
